import type { Country } from '../entities/Country';
import type { Currency } from '../entities/Currency';

export function isAsia({
  country,
  currency,
}: {
  country?: Country;
  currency?: Currency;
}): boolean {
  if (!country && !currency) {
    throw new Error('isAsia function requires either country or currency');
  }

  if (country) {
    if (['HK', 'ID', 'MY', 'PH', 'SG', 'TH', 'VN'].includes(country)) {
      return true;
    }
  }

  if (currency) {
    if (['HKD', 'IDR', 'MYR', 'PHP', 'SGD', 'THB'].includes(currency)) {
      return true;
    }
  }

  return false;
}
